import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSEO } from '../../utils/seo';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import BookingSection from './components/BookingSection';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';
import WhatsAppChat from '../../components/feature/WhatsAppChat';

export default function HomePage() {
  const location = useLocation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  // SEO Configuration
  useSEO({
    title: 'Urban Spaces - Interior Design & Digital Solutions',
    description: 'Award-winning interior design studio specializing in residential and commercial spaces with integrated digital solutions. Transform your space with Urban Spaces.',
    keywords: 'interior design, web development, digital solutions, residential design, commercial spaces, Urban Spaces',
    canonical: `${siteUrl}/`,
    ogType: 'website',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      '@id': `${siteUrl}/#organization`,
      name: 'Urban Spaces',
      url: siteUrl,
      logo: `${siteUrl}/logo.png`,
      description: 'Award-winning interior design studio specializing in residential and commercial spaces with integrated digital solutions.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Raysan',
        addressLocality: 'Gujarat',
        addressCountry: 'IN',
        postalCode: ''
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '23.0225',
        longitude: '72.5714'
      },
      telephone: '+91-XXXXXXXXXX',
      priceRange: '$$',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00'
        }
      ],
      sameAs: [
        'https://facebook.com/urbanspaces',
        'https://instagram.com/urbanspaces',
        'https://linkedin.com/company/urbanspaces'
      ],
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '127'
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Portfolio />
      <BookingSection />
      <Testimonials />
      <Blog />
      <CTABanner />
      <Footer />
      <WhatsAppChat />
    </div>
  );
}
